import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as Routes from 'modules/routes';
import axios from 'axios';
import QueryKeys from '@/utils/QueryKeys';
import { FilterOptions, TagType, IPaginationInfo } from '../types';

type UseTagTypes = {
  lessonIds?: number[],
  programId: number,
  page: number,
  perPage: number,
  setTags: (tags: TagType[]) => void,
  standardIds?: number[],
};

type TagsResponse = { filter_options?: FilterOptions, tags: TagType[], pagination: IPaginationInfo };

const useTags = ({ lessonIds = [], programId, page, perPage, setTags, standardIds = [] }: UseTagTypes) => {
  const path = Routes.plato_api_program_tags_tags_path({
    page,
    per_page: perPage,
    program_id: programId,
    ...(lessonIds.length > 0 && { lesson_ids: lessonIds }),
    ...(standardIds.length > 0 && { standard_ids: standardIds }),
  });

  const query = useQuery(
    [QueryKeys.Correlations, programId, page, perPage, standardIds, lessonIds],
    () => axios.get<TagsResponse>(path).then(res => res.data),
    { keepPreviousData: true, staleTime: Infinity },
  );

  // Syncing the store from an effect (not inside the query fn) keeps it in step with cached pages too.
  useEffect(() => {
    if (query.data) setTags(query.data.tags);
  }, [query.data]);

  return { ...query, data: query.data || {} as TagsResponse };
};

export default useTags;
